export default {
    set(key, val) {
        return sessionStorage.setItem(key, val)
    },
    get(key) {
        return sessionStorage.getItem(key)
    },
    remove(key) {
        return sessionStorage.removeItem(key)
    },
    clear() {
        return sessionStorage.clear()
    }
}